import createCrudService from 'utils/createCrudService'

const { getApiData, createApiRecord, getApiRecord, updateApiRecord, updateApiStatus } = createCrudService('user/groups')

export { getApiData, createApiRecord, getApiRecord, updateApiRecord, updateApiStatus }
